import { render, staticRenderFns } from "./MainCarousels.vue?vue&type=template&id=47c6562c&scoped=true&"
import script from "./MainCarousels.vue?vue&type=script&lang=js&"
export * from "./MainCarousels.vue?vue&type=script&lang=js&"
import style0 from "./MainCarousels.vue?vue&type=style&index=0&id=47c6562c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c6562c",
  null
  
)

export default component.exports